/**
 * Self-contained build-time feature flag for Wheel Collaboration (P4) — invite
 * users OUTSIDE your team to co-edit one specific wheel.
 *
 * Mirrors the established local-flag convention (ShareModal/featureFlag.js,
 * LinkedWheels/featureFlag.js). Defaults OFF; flipped per environment via the
 * REACT_APP_WHEEL_COLLABORATION build var (staging build sets it "true"). When
 * OFF the "Collaborators" menu item and the accept route are never rendered and
 * the app is byte-identical to today. Pairs with the backend
 * settings.WHEEL_COLLABORATION_ENABLED gate (routes 404 while OFF).
 */
const truthy = (v) => v === "true" || v === "1" || v === true;

export const WHEEL_COLLABORATION_ENABLED = truthy(
  process.env.REACT_APP_WHEEL_COLLABORATION
);

export default WHEEL_COLLABORATION_ENABLED;
